import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import BrandLogo from './BrandLogo';
import {currentBoardRoute,initializeBoardRoute} from './boardRoute';
import './styles.css';
import './desktopWorkspace.css';
import './brand.css';
import {productIdentity} from './productIdentity';

document.documentElement.dataset.productVersion=productIdentity.version;
document.documentElement.dataset.sourceRevision=productIdentity.sourceRevision;
document.title=`Graffiti ${productIdentity.version} — One street. Everyone’s canvas.`;

if(import.meta.env.DEV && window.location.pathname==='/dev/level-builder') {
  import('./level-builder/LevelBuilder').then(({default:LevelBuilder})=>{
    createRoot(document.getElementById('root')!).render(<React.StrictMode><LevelBuilder/></React.StrictMode>);
  }).catch(()=>{
    createRoot(document.getElementById('root')!).render(<main className="loading-screen"><BrandLogo className="loading-brand"/><h1>The level builder could not load.</h1><p>Check the development server and reload this page.</p></main>);
  });
}
else if(currentBoardRoute.kind==='root') {
  const root=createRoot(document.getElementById('root')!);
  const load=()=>{
    root.render(<main className="loading-screen"><BrandLogo className="loading-brand"/><p>Loading the main street…</p></main>);
    void initializeBoardRoute().then(()=>root.render(<React.StrictMode><App/></React.StrictMode>)).catch(()=>{
      root.render(<main className="loading-screen"><BrandLogo className="loading-brand"/><h1>The main street could not load.</h1><button onClick={load}>Try again</button><a href="/main">Visit the original street</a></main>);
    });
  };
  load();
}
else if(currentBoardRoute.kind==='admin') {
  const root=createRoot(document.getElementById('root')!);
  root.render(<main className="loading-screen"><BrandLogo className="loading-brand"/><p>Loading board administration…</p></main>);
  import('./AdminBoards').then(({default:AdminBoards})=>root.render(<React.StrictMode><AdminBoards/></React.StrictMode>)).catch(()=>{
    root.render(<main className="loading-screen"><BrandLogo className="loading-brand"/><h1>Board administration could not load.</h1><button onClick={()=>window.location.reload()}>Try again</button></main>);
  });
}
else createRoot(document.getElementById('root')!).render(<React.StrictMode>{currentBoardRoute.kind==='invalid'?<main className="loading-screen"><BrandLogo className="loading-brand"/><h1>This board address is unavailable.</h1><a href="/">Return to the main street</a></main>:<App/>}</React.StrictMode>);
